// extracted by mini-css-extract-plugin
export default {"finePrint":"SubmitFinePrint_finePrint__eth+t"};